import { createSelector } from 'reselect';

export const getActiveIntegrationObject = (state) =>
  state.hardware.integrations.activeIntegrations;

export const getActiveIntegrations = createSelector(
  getActiveIntegrationObject,
  (slice) => slice.value,
);

export const getActiveIntegrationsByType = (integrationType) =>
  createSelector(getActiveIntegrations, (slice) =>
    integrationType ? slice[integrationType] : '',
  );
